import { render, staticRenderFns } from "./StudentTaskList.vue?vue&type=template&id=8bb08358&"
import script from "./StudentTaskList.vue?vue&type=script&lang=js&"
export * from "./StudentTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports